export const PRODUCTION_APP_ORIGINS = {
  brokerage: "https://brokerage.quotewell.com",
} as const;
